import React, { createContext, useState, useEffect, useCallback } from "react";

const MQContext = createContext();

export const MQProvider = ({ children }) => {
  const [messageData, setMessageData] = useState(null);

  const handleMessageEvent = useCallback((event) => {
    try {
      setMessageData(event.detail);
    } catch (error) {
      console.error("Error parsing MQ message:", error);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("refreshProcess", handleMessageEvent);

    return () => {
      window.removeEventListener("refreshProcess", handleMessageEvent);
    };
  }, [handleMessageEvent]);

  return (
    <MQContext.Provider value={{ messageData }}>
      {children}
    </MQContext.Provider>
  );
};

export const useMQ = () => React.useContext(MQContext);